import { render, staticRenderFns } from "./OptionsMultiselect.vue?vue&type=template&id=1dd2777b&"
import script from "./OptionsMultiselect.vue?vue&type=script&lang=js&"
export * from "./OptionsMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports